import React from "react";
import { withRouter } from "react-router-dom";
import AccessImg from "./../../assets/img/accessDenied.png";
import * as message from "./../../config/CommonMessages";

const pathMessages = {
  "/generateImage-AccessDenied":
    "This feature isn’t available on your current plan.",
};

class AccessDenied extends React.Component {
  render() {
    const { location } = this.props;
    const currentPath = location.pathname;
    const customMessage = pathMessages[currentPath] || message.ACCESS_DENIED;

    return (
      <div className="error-page">
        <img src={AccessImg} alt="Access Denied" />
        <p>{customMessage}</p>
      </div>
    );
  }
}

export default withRouter(AccessDenied);
